import * as requestFromServer from "./crud";
import {balancesSlice, callTypes} from "./slices";
import {convertFilter} from "../../../utils/commonUtils";

const {actions} = balancesSlice;

export const fetchBalanceSummary = (date, queryParams) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.summary}));
  const status = queryParams.filter.balanceStatus;
  return requestFromServer
    .getBalanceSummary({date, status})
    .then(response => {
      const summary = response;
      dispatch(actions.summaryFetched({summary}));
    })
    .catch(error => {
      console.log(error)
      error.clientMessage = "Can't find links";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchSalesList = (date, queryParams) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const filter = convertFilter(queryParams);

  return requestFromServer
    .getSalesList({date, filter})
    .then(response => {
      const {pageInfo: {totalCnt}, salesList} = response;
      dispatch(actions.salesListFetched({totalCnt, salesList}));
    })
    .catch(error => {
      console.log(error)
      error.clientMessage = "Can't find sellers";
      dispatch(actions.catchError({error, callType: callTypes.sellers}));
    });
};

export const excelDownload = (date, queryParams) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .getExcelDownload(date, queryParams)
    .then(response => {
      const link = response;
      dispatch(actions.linkFetched({link}));
    })
    .catch(error => {
      error.clientMessage = "Can't find link";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};
